export const SIGNUP_CONFIRM_LINKS = {
  noShowPolicy: 'https://lifemd.com/consent-to-telehealth?popup=1#credit-card-policy',
  privacy: 'https://lifemd.com/privacy?popup=1',
  privacyPractices: 'https://lifemd.com/notice-of-privacy-practices/?popup=1',
  telehealth: 'https://lifemd.com/consent-to-telehealth?popup=1',
  terms: 'https://lifemd.com/terms?popup=1'
};

export const LINK_TO_FAQ =
  'https://support.lifemd.com/hc/en-us/articles/4413445509015-What-is-LifeMD-s-policy-on-prescribing-controlled-substances-';
export const LINK_CALL_HELP =
  'https://support.lifemd.com/hc/en-us/articles/4418910761751-Video-Conferencing-Options-and-Troubleshooting-Tips';
// export const LINK_TO_LOCAL_URGENT_CARE = 'https://www.google.com/search?q=local+urgent+care';
// export const LINK_TO_LOCAL_EMERGENCY_SERVICES =
//   'https://www.google.com/search?q=local+emergency+services';
export const LINK_TO_SUPPORT = 'https://support.lifemd.com/hc/en-us';
export const LINK_TO_PATIENT_SAFETY =
  'https://lifemd.atlassian.net/servicedesk/customer/portal/113';
export const AI_ASSISTANT_CHAT_URL = `https://www.stack-ai.com/chat/${import.meta.env.VITE_AI_ASSISTANT_CHAT_ID}`;
type ShippingCarrier = 'fedex' | 'ups' | 'usps';

const CARRIER_TRACKING_URLS: Record<ShippingCarrier, string> = {
  fedex: 'https://www.fedex.com/fedextrack/?trknbr=',
  ups: 'https://www.ups.com/track?track=yes&trackNums=',
  usps: 'https://tools.usps.com/go/TrackAction?qtc_tLabels1='
};

const GOOGLE_SEARCH_TRACKING_URL = 'https://www.google.com/search?q=';

function detectCarrier(trackingNumber: string): ShippingCarrier | null {
  const tn = trackingNumber.trim();

  if (/^1Z[A-Z0-9]{16}$/i.test(tn)) return 'ups';

  if (/^(94|93|92|91)\d{18}$/.test(tn)) return 'usps';
  if (/^420\d{23,31}$/.test(tn)) return 'usps';
  if (tn.length === 13 && /^[A-Z]{2}/i.test(tn)) return 'usps';

  if (/^\d{12}$/.test(tn)) return 'fedex';
  if (/^\d{15}$/.test(tn)) return 'fedex';

  if (/^\d{20,22}$/.test(tn)) return 'usps';

  return null;
}

export function getTrackingUrl(trackingNumber: string): string {
  const trimmed = (trackingNumber ?? '').trim();
  const carrier = detectCarrier(trimmed);
  const baseUrl = carrier ? CARRIER_TRACKING_URLS[carrier] : GOOGLE_SEARCH_TRACKING_URL;
  return baseUrl + encodeURIComponent(trimmed);
}
export const PRESCRIPTION_INSTRUCTIONS_URL =
  'https://lifemd.com/portal/content/administering-compounded-medication.php';
export const WEIGHT_MANAGEMENT_VIDEO_URL =
  'https://player.vimeo.com/video/849391069?h=1d4a5a0704&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';
export const LINK_TO_ACCESSING_APPOINTMENTS =
  'https://support.lifemd.com/hc/en-us/articles/4413826265623';
export const LINK_TO_POSTHOG = 'https://d296b1gzk3kiqi.cloudfront.net';
export const TRUST_PILOT_URL = 'https://www.trustpilot.com/review/lifemd.com';
export const LINK_TO_TRACKQUANT = 'https://click.trackquant.com';
export const LINK_TO_SCHEDULE_LABS = 'https://appointment.questdiagnostics.com/as-home';
export const LINK_TO_AT_HOME_LABS = 'https://lifemd.com/at-home-labs';
export const LINK_TO_ACCESSIBILITY = 'https://lifemd.com/accessibility';
export const LINK_TO_MEMBERSHIP = 'https://www.lifemd.com/membership';
export const LINK_TO_LIFEMD = 'https://lifemd.com';

export const MENTAL_HEALTH_DAILY_VIDEO_URL =
  'https://player.vimeo.com/video/1098288029?h=913d48c7f0&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';
export const MENTAL_HEALTH_AS_NEEDED_VIDEO_URL =
  'https://player.vimeo.com/video/1098288059?h=53fa2f0507&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';
export const WH_ONBOARDING_FLOW =
  import.meta.env.VITE_ENV === 'production'
    ? 'https://rx.lifemd.com/womens-health/?affid=test&force=1'
    : 'https://sdv1.stage.lifemd.com/wh-stage';
export const WINBACK_SD_FLOW =
  import.meta.env.VITE_ENV === 'production'
    ? 'https://rx.lifemd.com/wc-wb/'
    : 'https://sdv1.stage.lifemd.com/wc-wb-stage';
export const WM_ONBOARDING_FLOW =
  import.meta.env.VITE_ENV === 'production'
    ? 'https://rx.lifemd.com/wc-primary'
    : 'https://sdv1.stage.lifemd.com/wc-primary';
export const MH_ONBOARDING_FLOW =
  import.meta.env.VITE_ENV === 'production'
    ? 'https://rx.lifemd.com/mental-health'
    : 'https://sdv1.stage.lifemd.com/mental-health';

/**
 * AT&T &More Benefits management surface (LMD-1095). Patients are sent here to manage or
 * unlink their AT&T benefit — LifeMD never edits the entitlement itself.
 */
export const ATT_MANAGE_BENEFIT_LINK =
  import.meta.env.VITE_ENV === 'production'
    ? 'https://andmorebenefits.att.com/root-mybenefits'
    : 'https://attus-storefront-pre003.pdt.ifs.m1amdocs.io/root-mybenefits';

/** Global setting uid for the AT&T "Talk to a doctor" funnel (LMD-1394). Mirrors `GLOBAL_SETTING_ID`. */
export const ATT_TALK_TO_A_DOCTOR_LINK_SETTING_UID = 'stardustAttTalkToADoctorLink';
